module.exports = __webpack_public_path__ + "img/62_7.34cf5893.png";